import { Component, Input, OnChanges } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ClientPresenceService, ClientPresenceState } from '@app/core/services/client-presence.service';
import { Credit } from '@app/core/types/credit';

// "Заявка 1234 / Client Name" (or "Кредит 1234 / ..." once contracted) with the client's live website
// status underneath as a second line (онлайн / офлайн / няма данни).
@Component({
  selector: 'itfg-client-credit-title',
  templateUrl: './client-credit-title.component.html',
  styleUrl: './client-credit-title.component.scss',
  standalone: false,
})
export class ClientCreditTitleComponent implements OnChanges {
  @Input() credit: Credit;

  state$: Observable<ClientPresenceState> = of('unknown');

  constructor(private presence: ClientPresenceService) {}

  ngOnChanges() {
    this.state$ = this.presence.state$(this.credit?.user);
  }
}
